export default __webpack_public_path__ + "static/media/element_spec_83.ddd865d4.webp";